import { gql } from '@parkchirp/api-client';

export const LIST_RESERVATION_ACCESS_SYSTEM_HISTORY = gql`
  query listReservationAccessSystemHistory(
    $limit: Int!
    $offset: Int!
    $filters: [Filter]
    $order: SortOrder
  ) {
    listReservationAccessSystemHistory(
      limit: $limit
      offset: $offset
      filters: $filters
      order: $order
    ) {
      total
      reservationAccessSystemHistory {
        id
        createdAt
        createdBy
        sessionId
        sessionHash
        status
        action
        responseMessage
        facilityId
        facilityName
        facilityNumber
        facilityTimezone
        integration
        createdByUser {
          email
          firstName
          lastName
          internalUseOnly
        }
      }
    }
  }
`;

export const GET_RASH_DETAILS = gql`
  query getRashDetails($id: Int!) {
    getRashDetails(id: $id) {
      response
    }
  }
`;
